import social_media from '../../../images/social_media.jpg'
import macro from '../../../images/macro.jpg'
import credit_cards from '../../../images/credit_cards.jpg'
import jobs from '../../../images/jobs.jpg'
import web_traffic from '../../../images/web_traffic.jpg'
import company from '../../../images/company.jpg'
import news from '../../../images/news.jpg'
import data from '../../../images/data.jpg'

const imports = {
    'Social Media': social_media,
    'Macro': macro,
    'Credit Cards and Transactions Data': credit_cards,
    'Jobs and Employees': jobs,
    'Traffic and Usage': web_traffic,
    'Company Operational Data': company,
    'News Sentiment': news,
    'default': data
}

export const DiscoverCardImage = (data_type) => { 
    return imports[data_type] || imports['default']
}